<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 12.4961H2C1.44772 12.4961 1 12.0484 1 11.4961V3.49609C1 2.94381 1.44772 2.49609 2 2.49609H14C14.5523 2.49609 15 2.94381 15 3.49609V11.4961C15 12.0484 14.5523 12.4961 14 12.4961H13.5"
      stroke="#868D9C"
      stroke-width="2"
      stroke-linecap="round"
    />
    <path
      d="M9.86512 12.4067C9.82837 12.3701 9.80114 12.325 9.78581 12.2754C9.77048 12.2258 9.76751 12.1732 9.77716 12.1222C9.78681 12.0712 9.80879 12.0234 9.84119 11.9828C9.87358 11.9422 9.9154 11.9102 9.96301 11.8895L11.8097 11.1806C11.8678 11.1542 11.9165 11.1111 11.9498 11.0567C11.983 11.0023 11.9991 10.9392 11.9961 10.8756C11.993 10.8119 11.9709 10.7507 11.9327 10.6997C11.8944 10.6488 11.8418 10.6104 11.7815 10.5898L5.41201 8.51019C5.3567 8.49316 5.2978 8.49153 5.24163 8.50547C5.18546 8.51941 5.13416 8.5484 5.09324 8.58932C5.05232 8.63023 5.02332 8.68153 5.00938 8.73768C4.99543 8.79384 4.99707 8.85274 5.0141 8.90804L7.09282 15.2776C7.11352 15.3379 7.15183 15.3905 7.2028 15.4288C7.25376 15.467 7.31504 15.4891 7.37869 15.4922C7.44234 15.4952 7.50545 15.4791 7.55983 15.4459C7.61421 15.4126 7.65737 15.3639 7.68373 15.3059L8.39282 13.4594C8.41352 13.4118 8.44555 13.37 8.48612 13.3376C8.52668 13.3053 8.57455 13.2833 8.62556 13.2736C8.67657 13.264 8.72916 13.267 8.77876 13.2823C8.82835 13.2976 8.87345 13.3248 8.91011 13.3616L10.9518 15.4029C11.0115 15.4626 11.0925 15.4961 11.1769 15.4961C11.2612 15.4961 11.3422 15.4626 11.4019 15.4029L11.9068 14.8993C11.9665 14.8396 12 14.7587 12 14.6743C12 14.5899 11.9665 14.509 11.9068 14.4493L9.86512 12.4067Z"
      fill="#868D9C"
    />
  </svg>
</template>
